<template>
  <div ref="container">
    <a-modal
      title="添加账号"
      :width="560"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取 消"
      okText="确 定"
      style="top:120px;">
      <a-spin :spinning="confirmLoading">
        <!-- 云贝 Tab3"账号密码"字段克隆：登录账号/登录密码/绑定手机号；姓名为 ERP 用户体系必填项 -->
        <a-form class="account-form">
          <a-form-item label="登录账号" required :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
            <a-input v-model="accountForm.userName" autocomplete="off" placeholder="请输入登录账号" style="width: 300px" />
            <div class="field-tip">账号请不要用中文</div>
          </a-form-item>
          <a-form-item label="姓名" required :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
            <a-input v-model="accountForm.username" autocomplete="off" placeholder="请输入姓名" style="width: 300px" />
          </a-form-item>
          <a-form-item label="登录密码" required :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
            <a-input v-model="accountForm.password" type="password" autocomplete="off" placeholder="请输入登录密码" style="width: 300px" />
            <div class="field-tip">用户密码至少要有数字和小写字母，并且长度至少6位</div>
          </a-form-item>
          <a-form-item label="绑定手机号" required :labelCol="{ span: 5 }" :wrapperCol="{ span: 18 }">
            <a-input v-model="accountForm.bindTel" autocomplete="off" placeholder="请输入绑定手机号" style="width: 300px" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import md5 from 'md5'
import { getAction, postAction, putAction } from '@/api/manage'
import { roleAllList } from '@/api/api'
import { mixinDevice } from '@/utils/mixin'

/**
 * 门店收银员账号添加弹窗（StoreInfo.vue Tab3"账号密码"落地：jsh_user + jsh_store_user）
 * 流程（全走既有接口）：/user/addUser 创建用户 → /user/list 按登录名查新用户 id
 *   → 复用一期绑定接口 PUT /store/{id}/users（userIds 整体替换，追加新用户）
 */
const OLD_STORE_PREFIX = '/api/plugin/dining/store'

export default {
  name: 'DiningStoreAccountModal',
  mixins: [mixinDevice],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      storeId: null,
      storeName: '',
      accountForm: {
        userName: '',
        username: '',
        password: '',
        bindTel: ''
      }
    }
  },
  methods: {
    show(store) {
      this.storeId = store.id
      this.storeName = store.name
      this.accountForm = { userName: '', username: '', password: '', bindTel: '' }
      this.visible = true
    },
    handleOk() {
      const form = this.accountForm
      if (!form.userName || !form.userName.trim()) {
        this.$message.warning('请输入登录账号')
        return
      }
      if (/[\u4e00-\u9fa5]/.test(form.userName)) {
        this.$message.warning('账号请不要用中文')
        return
      }
      if (!form.username || !form.username.trim()) {
        this.$message.warning('请输入姓名')
        return
      }
      if (!form.password || !/^(?=.*[a-z])(?=.*\d).{6,}$/.test(form.password)) {
        this.$message.warning('用户密码至少要有数字和小写字母，并且长度至少6位')
        return
      }
      if (!form.bindTel || !form.bindTel.trim()) {
        this.$message.warning('请输入绑定手机号')
        return
      }
      // ERP 用户体系要求必须挂角色（UserService.checkRoleAndOrg 按 roleId 取角色类型），
      // 此处默认取租户第一个角色，创建后可在系统管理-用户管理中调整
      roleAllList({}).then(roleRes => {
        const roleList = Array.isArray(roleRes) ? roleRes : (roleRes && roleRes.data) || []
        if (!roleList.length) {
          this.$message.warning('请联系管理员先创建角色')
          return
        }
        this.createUser(roleList[0].id)
      })
    },
    // 步骤1：创建 jsh_user（登录账号=loginName，姓名=username，手机号=phonenum，密码 md5，职位=收银员）
    createUser(roleId) {
      const that = this
      const form = this.accountForm
      that.confirmLoading = true
      postAction('/user/addUser', {
        loginName: form.userName.trim(),
        username: form.username.trim(),
        phonenum: form.bindTel.trim(),
        password: md5(form.password),
        position: '收银员',
        roleId: roleId
      }).then(res => {
        if (res.code === 200) {
          that.findUserIdAndBind()
        } else {
          that.$message.warning((res.data && res.data.message) || res.message || '创建用户失败')
          that.confirmLoading = false
        }
      }).catch(() => {
        that.confirmLoading = false
      })
    },
    // 步骤2：按登录名查新用户 id（checkLoginName 保证登录名唯一）
    findUserIdAndBind() {
      const that = this
      getAction('/user/list', { search: JSON.stringify({ loginName: this.accountForm.userName.trim() }) }).then(res => {
        const rows = (res && res.data && res.data.rows) || []
        if (!rows.length) {
          that.$message.warning('创建用户成功但未查询到该用户，请手动在门店绑定')
          that.confirmLoading = false
          that.finish()
          return
        }
        that.bindToStore(rows[0].id)
      }).catch(() => {
        that.confirmLoading = false
      })
    },
    // 步骤3：复用一期绑定接口（GET 已绑定 + PUT 整体替换，追加新用户）
    bindToStore(userId) {
      const that = this
      getAction(`${OLD_STORE_PREFIX}/${this.storeId}/users`).then(res => {
        const bound = (res.code === 200 && res.data) || []
        const userIds = bound.map(u => u.id)
        if (userIds.indexOf(userId) === -1) {
          userIds.push(userId)
        }
        return putAction(`${OLD_STORE_PREFIX}/${that.storeId}/users`, { userIds: userIds }).then(bindRes => {
          if (bindRes.code === 200) {
            that.$message.success(bindRes.message || '添加成功')
          } else {
            that.$message.warning(bindRes.message)
          }
        })
      }).finally(() => {
        that.confirmLoading = false
        that.finish()
      })
    },
    finish() {
      this.visible = false
      this.$emit('ok')
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped>
.account-form {
  max-width: 460px;
}
.field-tip {
  color: #999;
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
}
</style>
